// OEM App 定制 — 定制项目归档 mock
// 归档为项目级标记：已归档项目从「定制管理」主列表隐藏，移入独立「已归档」抽屉列表
// TODO: 联调时替换为接口数据

// 已归档项目（项目 id → { archivedAt }）
export const INITIAL_ARCHIVED = {
    'OEM-1012': { archivedAt: '2026-09-01 09:30' },
    'OEM-1013': { archivedAt: '2026-09-02 14:10' },
};

export const nowStr = () => new Date().toLocaleString('zh-CN', { hour12: false });
